import useBreakpoint from '@common/utils/useBreakpoint';
import imageutils, { MD, SM, XS, XXS, LG } from '@utils/imageutils';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';
const defaultSizes = [XXS, XS, SM, MD];
const ProductImage = (props) => {
    var _a;
    const currentBreakpoint = useBreakpoint();
    const image = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        if (props.index) {
            return (_a = props.img) === null || _a === void 0 ? void 0 : _a.urls[props.index];
        }
        let img;
        if (props.type) {
            let imageoldsuffix = '_' + props.type + '.';
            let imagenewsuffix = '_' + props.type + '1.';
            img = (_c = (_b = props.img) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.find((u) => u && (u.includes(imageoldsuffix) || u.includes(imagenewsuffix)));
        }
        if (!img && props.typeFallback) {
            const typeFallbackSuffix = '_' + props.typeFallback;
            img = (_e = (_d = props.img) === null || _d === void 0 ? void 0 : _d.urls) === null || _e === void 0 ? void 0 : _e.find((u) => u.includes(typeFallbackSuffix));
        }
        if (img) {
            return img;
        }
        else {
            return (_f = props.img) === null || _f === void 0 ? void 0 : _f.urls[0];
        }
    }, [props.img, props.index, props.type]);
    const el = useRef();
    const lowResImg = useMemo(() => { var _a; return imageutils.transform(image, XXS, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt); }, [image]);
    const hiResImage = useMemo(() => {
        var _a, _b;
        //@ts-ignore disable-next-line
        if (currentBreakpoint >= window.mqObj.md) {
            return imageutils.transform(image, LG, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt, null, 'avif');
        }
        else {
            return imageutils.transform(image, MD, (_b = props.img) === null || _b === void 0 ? void 0 : _b.alt, null, 'avif');
        }
    }, [currentBreakpoint, image]);
    const multipleSrc = useMemo(() => {
        let srcs = [];
        (props.sizes || defaultSizes).forEach((sz, i) => {
            var _a;
            srcs.push(`${imageutils.transform(image, sz, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt)} ${sz.width}w`);
        });
        return srcs.join(', ');
    }, [image]);
    const multipleSrcAvif = useMemo(() => {
        let srcs = [];
        (props.sizes || defaultSizes).forEach((sz, i) => {
            var _a;
            srcs.push(`${imageutils.transform(image, sz, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt, null, 'avif')} ${sz.width}w`);
        });
        return srcs.join(', ');
    }, [image]);
    const altText = useMemo(() => {
        var _a, _b;
        const index = (_a = props.seoIndex) !== null && _a !== void 0 ? _a : props.index;
        return `${props.alt || ((_b = props.img) === null || _b === void 0 ? void 0 : _b.alt)}${index >= 0 ? ` ${index + 1}` : ''}`;
    }, [image]);
    useEffect(() => {
        props.onHasImage && props.onHasImage(!!image);
    }, [image]);
    const lazyPosterImg = useMemo(() => {
        return props.lazyLowRes ? lowResImg : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }, [image]);
    const imageElement = (React.createElement("picture", { className: classNames({ lazyload: !props.lazyDisabled }, props.className) },
        React.createElement("source", Object.assign({}, (!props.lazyDisabled && { ['data-srcset']: multipleSrcAvif }), { srcSet: props.lazyDisabled ? multipleSrcAvif : lazyPosterImg, type: "image/avif" })),
        React.createElement("source", Object.assign({}, (!props.lazyDisabled && { ['data-srcset']: multipleSrc }), { srcSet: props.lazyDisabled ? multipleSrc : lazyPosterImg, type: "image/webp" })),
        React.createElement("img", { ref: props.ref || el, alt: altText, src: props.lazyDisabled ? hiResImage : lowResImg, "data-sizes": "auto", "data-idx": props.index || 0, className: classNames({ lazyload: !props.lazyDisabled }, props.className), "data-quality-img": hiResImage, width: XXS.width, height: XXS.height, style: props.style, "aria-hidden": (props === null || props === void 0 ? void 0 : props.ariaHidden) != undefined ? props === null || props === void 0 ? void 0 : props.ariaHidden : !!props.alt || !!((_a = props.img) === null || _a === void 0 ? void 0 : _a.alt) })));
    if (props.onlyImage) {
        return imageElement;
    }
    if (!props.img || !image) {
        return (React.createElement("div", { className: "product-image", "data-tiletype": props.tiletype, "data-type": props.type },
            React.createElement("img", { alt: altText, src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", "data-idx": props.index || 0, className: props.className, width: XXS.width, height: XXS.height, style: props.style })));
    }
    return (React.createElement("div", { className: "product-image", "data-tiletype": props.tiletype, "data-type": props.type }, imageElement));
};
export default ProductImage;
